
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","transform":"matrix(1 0 0 -1 0 26)","fill":"#EE2222","fill-opacity":"0.25"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 6.5C12.6667 6.5 12.3965 6.79469 12.3965 7.15821V17.2528L8.8301 13.3626C8.59446 13.1055 8.21237 13.1055 7.97673 13.3626C7.74103 13.6197 7.74103 14.0364 7.97673 14.2935L12.5733 19.3072C12.8089 19.5643 13.191 19.5643 13.4266 19.3072L18.0232 14.2935C18.2589 14.0364 18.2589 13.6197 18.0232 13.3626C17.7876 13.1055 17.4055 13.1055 17.1698 13.3626L13.6034 17.2528V7.15821C13.6034 6.79469 13.3332 6.5 13 6.5Z","fill":"#DD3B3B"}})])
          )
        }
      }
    